module.exports = __webpack_public_path__ + "img/nmhxpg.fac70bd5.png";